export default "__VITE_ASSET__caKPBI79__"